export const HTTP_URL_PATTERN = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g;

export function isBaseUrl(url: string) {
  return url === '/' || url === '/en/' || url === '/ja/';
}

function isCloudinaryUrl(url: string) {
  return url.includes('https://res.cloudinary.com');
}

export function ensureUrl(url: string) {
  if (typeof url === 'string') {
    const noMultiSlash = url.replace(/\/+/g, '/');
    const httpReplaced = noMultiSlash.replace('http:/', 'http://');
    return httpReplaced.replace('https:/', 'https://');
  }

  return '';
}

export function addTransformToCloudinaryUrl(
  url: string,
  { rounded = false, width = 70, thumbed = false } = {}
) {
  if (!isCloudinaryUrl(url)) {
    return url;
  }

  const target = '/upload/';
  const uploadIdx = url.indexOf(target);
  const idx = uploadIdx + target.length;
  const transform = `c_scale,w_${width}${rounded ? ',r_max' : ''}${
    thumbed ? ',c_thumb' : ''
  },dpr_2.0,f_auto`;

  return `${url.substring(0, idx)}${transform}/${url.substring(idx)}`;
}

export function getOptimizedCloudinaryUrl(url: string) {
  const NUMBER_OF_PARTS_WITHOUT_TRANSFORM = 8;
  const NUMBER_OF_PARTS_WITH_TRANSFORM = 9;
  const TRANSFORM_PART_INDEX = 6;
  if (!isCloudinaryUrl(url)) {
    return url;
  }

  const parts = url.split('/');
  const doesUrlContainTransformation = parts.length === NUMBER_OF_PARTS_WITH_TRANSFORM;
  const doesUrlNotContainTransformation = parts.length === NUMBER_OF_PARTS_WITHOUT_TRANSFORM;
  const isUrlRecognized = doesUrlContainTransformation || doesUrlNotContainTransformation;

  if (!isUrlRecognized) {
    return url;
  }

  if (doesUrlContainTransformation) {
    parts[TRANSFORM_PART_INDEX] += ',f_auto';
  } else {
    parts.splice(TRANSFORM_PART_INDEX, 0, 'f_auto');
  }

  return parts.join('/');
}
